export default {
  session: {
    auth: false,
    guest: false,
    token: undefined,
  },
  profile: {
    options: undefined,
    role: undefined,
    isFinalized: false,
  },
  user: undefined,
  usageDatas: undefined,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js